import { render, staticRenderFns } from "./BaseFloatingMobile.vue?vue&type=template&id=ec9c8aca"
import script from "./BaseFloatingMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFloatingMobile.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports